import Api from '../../../../shared/Api';

export type FilmFile = {
    id: number;
    filename: string;
    reference: string;
    uploadedTime_Local: string;
    sentTime_Local: string | null;
    sentToEmail: string | null;
};

export type OrderFilm = {
    orderRowId: number;
    productName: string;
    isSoMeFilm: boolean;
    isDelivered: boolean;
    files: FilmFile[];
};

export type OrderFilms = {
    films: OrderFilm[];
};

export type LinkInfo = {
    sentToEmail: string;
    sentByUsername: string;
    links: string[];
    linksSentTime: string;
};

class OrderFilmApi {
    static getOrderFilms(orderId: number): Promise<OrderFilms> {
        return new Api().get(`/views/orders/${orderId}/films`);
    }

    static getOrderFilmLinks(orderId: number): Promise<LinkInfo[]> {
        return new Api().get(`/views/orders/${orderId}/film/links`);
    }

    static sendFilm(orderId: number, orderFilmId: number, email: string): Promise<OrderFilms> {
        return new Api().post(`/views/orders/${orderId}/films/file/${orderFilmId}/send`, {
            email: email
        });
    }

    static removeFilmFile(orderId: number, orderFilmId: number): Promise<OrderFilms> {
        return new Api().delete(`/views/orders/${orderId}/films/file/${orderFilmId}`);
    }

    static sendLinks(orderId: number, email: string, links: string[]): Promise<void> {
        return new Api().post(`/views/orders/${orderId}/film/send-links`, {
            email,
            links
        });
    }

    static combineFilm(
        orderId: number,
        orderRowId: number,
        resumableFilename: string,
        resumableIdentifier: string,
        resumableTotalChunks: number,
        contentType: string
    ): Promise<OrderFilms> {
        return new Api().post(`/views/orders/${orderId}/films/${orderRowId}/combine`, {
            resumableFilename: resumableFilename,
            resumableIdentifier: resumableIdentifier,
            resumableTotalChunks: resumableTotalChunks,
            contentType: contentType
        });
    }
}

export default OrderFilmApi;
